/**
 * FH Testimonials Slider
 * Custom Element for testimonial carousel with navigation and autoplay
 */

if (!customElements.get('fh-testimonial-slider')) {
  class FHTestimonialSlider extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.autoplayInterval = null;
      this.isAutoplayEnabled = false;
      this.autoplaySpeed = 5000;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');

      if (!this.track) return;

      // Get autoplay settings from data attributes
      this.isAutoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

      this.bindEvents();
      this.updateNavigation();

      if (this.isAutoplayEnabled) {
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    bindEvents() {
      // Navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollPrev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollNext());
      }

      // Update navigation state on scroll
      this.track.addEventListener('scroll', () => {
        this.updateNavigation();
      });

      // Pause autoplay on interaction
      this.track.addEventListener('mouseenter', () => {
        if (this.isAutoplayEnabled) {
          this.stopAutoplay();
        }
      });

      this.track.addEventListener('mouseleave', () => {
        if (this.isAutoplayEnabled) {
          this.startAutoplay();
        }
      });

      // Handle touch for autoplay pause
      this.track.addEventListener('touchstart', () => {
        if (this.isAutoplayEnabled) {
          this.stopAutoplay();
        }
      }, { passive: true });

      this.track.addEventListener('touchend', () => {
        if (this.isAutoplayEnabled) {
          this.startAutoplay();
        }
      }, { passive: true });
    }

    getCardWidth() {
      const card = this.track.querySelector('.fh-testimonials__card');
      if (!card) return 300;
      
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.gap) || 20;
      return card.offsetWidth + gap;
    }

    scrollPrev() {
      const scrollAmount = this.getCardWidth();
      this.track.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    }

    scrollNext() {
      const scrollAmount = this.getCardWidth();
      this.track.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }

    updateNavigation() {
      if (!this.prevBtn || !this.nextBtn) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const isAtStart = scrollLeft <= 1;
      const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      this.prevBtn.disabled = isAtStart;
      this.nextBtn.disabled = isAtEnd;
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;

        if (isAtEnd) {
          // Loop back to start
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scrollNext();
        }
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  customElements.define('fh-testimonial-slider', FHTestimonialSlider);
}
